/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_PetrolInputs */

const en_val_petrol = /** @type {(inputs: Val_PetrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petrol`)
};

const es_val_petrol = /** @type {(inputs: Val_PetrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gasolina`)
};

const fr_val_petrol = /** @type {(inputs: Val_PetrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essence`)
};

const de_val_petrol = /** @type {(inputs: Val_PetrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benzin`)
};

const ja_val_petrol = /** @type {(inputs: Val_PetrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ガソリン`)
};

const zh_val_petrol = /** @type {(inputs: Val_PetrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`汽油`)
};

const ar_val_petrol = /** @type {(inputs: Val_PetrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنزين`)
};

const id_val_petrol = /** @type {(inputs: Val_PetrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bensin`)
};

const it_val_petrol = /** @type {(inputs: Val_PetrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benzina`)
};

const ru_val_petrol = /** @type {(inputs: Val_PetrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бензин`)
};

const pt_val_petrol = /** @type {(inputs: Val_PetrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gasolina`)
};

const ko_val_petrol = /** @type {(inputs: Val_PetrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가솔린(휘발유)`)
};

/**
* | output |
* | --- |
* | "Petrol" |
*
* @param {Val_PetrolInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_petrol = /** @type {((inputs?: Val_PetrolInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_PetrolInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_petrol(inputs)
	if (locale === "es") return es_val_petrol(inputs)
	if (locale === "fr") return fr_val_petrol(inputs)
	if (locale === "de") return de_val_petrol(inputs)
	if (locale === "ja") return ja_val_petrol(inputs)
	if (locale === "zh") return zh_val_petrol(inputs)
	if (locale === "ar") return ar_val_petrol(inputs)
	if (locale === "id") return id_val_petrol(inputs)
	if (locale === "it") return it_val_petrol(inputs)
	if (locale === "ru") return ru_val_petrol(inputs)
	if (locale === "pt") return pt_val_petrol(inputs)
	return ko_val_petrol(inputs)
});